export class PromiseDelegate {
    promise;
    resolveInternal;
    rejectInternal;
    constructor() {
        this.promise = new Promise((resolve, reject) => {
            this.resolveInternal = resolve;
            this.rejectInternal = reject;
        });
    }
    resolve(value) {
        this.resolveInternal(value);
    }
    reject(reason) {
        this.rejectInternal(reason);
    }
}
//# sourceMappingURL=promise-delegate.js.map